import { render } from "./I.vue?vue&type=template&id=3f901e6a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/I.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f901e6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f901e6a', __exports__)) {
    api.reload('3f901e6a', __exports__)
  }
  
  module.hot.accept("./I.vue?vue&type=template&id=3f901e6a", () => {
    api.rerender('3f901e6a', render)
  })

}


export default __exports__